import type { BoxProps } from '@bos/ui';
import { styled } from 'styletron-react';

import { appSizes } from '../../../const/appSizes';
import { appStaticColors } from '../../../const/colors/appStaticColors';

export const AppIconBackground = styled<'div', BoxProps>('div', () => ({
	backgroundColor: appStaticColors.iconBackground,
	borderRadius: appSizes.iconBackground.borderRadius,
	padding: appSizes.iconBackground.padding,
}));
